<template>
  <modalWindow v-if="publicFilesModal" @close="closeModal()" width="600">
    <div class="titlebar">
      <template v-if="!uploadForm">Publieke bestanden</template>
      <template v-else>Bestanden uploaden</template>
    </div>
    <template v-if="!uploadForm">
      <div class="form-notice" v-if="tooltipText">
          {{tooltipText}}
      </div>
      <table>
        <tr
          v-for="file in slice(
            publicFiles,
            publicFilesPage * publicFilesResultsPerPage,
            (publicFilesPage + 1) * publicFilesResultsPerPage)
          "
          :key="file.id"
        >
          <td style="white-space:nowrap;">{{toTextDate(file)}}</td>
          <td style="word-break:break-all;">{{file.path}}</td>
          <td class="number">
              <a
              @click="download(file.path)"
              class="secondary"
              ><awesomeIcon icon="download"/><span class="download-txt"> Download</span>
              </a>
          </td>
          <td class="number">
              <a
              @click="deletePublicFile(file.path)"
              class="secondary"
              ><awesomeIcon icon="trash"/><span class="download-txt"> Delete</span>
              </a>
          </td>
          </tr>
          <tr>
            <td colspan="4">
              <div class="pagebar">
                <button
                  v-if="publicFilesPage !== 0"
                  @click="publicFilesPage -= 1"
                  title="Vorige pagina"
                >
                  <awesomeIcon icon="chevron-left"/>
                </button>
                <span class="pagination">Pag. {{ publicFilesPage + 1 }}</span>
                  <button
                    v-if="slice(
                      publicFiles,
                      (publicFilesPage + 1) * publicFilesResultsPerPage,
                      (publicFilesPage + 2) * publicFilesResultsPerPage).length > 0"
                    @click="publicFilesPage += 1"
                    title="Volgende pagina"
                  >
                    <awesomeIcon icon="chevron-right"/>
                  </button>
              </div>
            </td>
          </tr>
      </table>
    </template>
    <form @submit.prevent v-else class="inset">
      <label
        for="publicuploadfile" class="file-label button"
        style="display:block;height:initial;"
      >
        <awesomeIcon icon="upload"/> Bestanden uploaden
      </label>
      <input
        style="display:none;" ref="files" id="publicuploadfile"
        type="file" name="img" multiple @change="uploadFilesChanged"
      >
    </form>
    <a class="block-button" @click="uploadForm=true; tooltipText = '';"  v-if="!uploadForm">
      <awesomeIcon icon="upload"/> Veilig bestanden uploaden
    </a>
    <a class="block-button" @click="uploadForm=false" v-else>
      <awesomeIcon icon="chevron-left"/> Terug
    </a>
  </modalWindow>
</template>

<script>
import { slice } from 'lodash-es';

export default {
  name: 'UserPublicFiles',
  data() {
    return {
      user: null,
      publicFilesModal: false,
      publicFiles: [],
      publicFilesPage: 0,
      publicFilesResultsPerPage: 20,
      tooltipText: '',
      uploadForm: false,
    };
  },
  computed: {
    port() {
      return this.$store.state.currentPort;
    },
  },
  methods: {
    slice,
    closeModal() {
      this.publicFilesModal = false;
      this.uploadForm = false;
      this.tooltipText = '';
    },
    toTextDate(file) {
      return new Date(parseInt(file.path.slice(7, 20), 10)).toLocaleDateString();
    },
    getUserPublicFiles(user) {
      this.publicFiles = [];
      this.publicFilesPage = 0;
      this.publicFilesModal = true;
      this.user = user;
      this.sdk.getUserPublicFiles(user, (response) => {
        this.publicFiles = response.data;
      });
    },
    download(file) {
      this.sdk.getUserPublicFile(this.user, file);
    },
    deletePublicFile(file) {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u dit bestand wilt verwijderen?',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.deleteUserPublicFile(this.user, file, () => {
              this.getUserPublicFiles(this.user);
            });
          }
        },
      });
    },
    uploadFilesChanged(e) {
      this.publicFilesModal = true;
      this.uploadPublicFiles(e.target.files.length);
    },
    uploadPublicFiles() {
      this.sdk.addUploadPublicFile(
        this.user,
        this.$refs.files.files,
        (response) => {
          if (response.status === 200) {
            // success
            this.tooltipText = 'We hebben uw bestanden ontvangen.';
          } else {
            this.tooltipText = 'Fout met uploaden. Wij accepteren alleen afbeeldingen en pdf bestanden.';
          }
          this.getUserPublicFiles(this.user);
          this.uploadForm = false;
        },
      );
    },
  },
};
</script>
